import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const Loader: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <img
        src="/images/logos/logo-blue.png"
        alt="Studcorp Logo"
        style={{ height: 80, marginBottom: 16 }}
      />
      <CircularProgress size={40} thickness={4} color="primary" />
    </Box>
  );
};

export default Loader;
